import { type Area } from "react-easy-crop";
import { atom } from "recoil";

export const croppedAreaPixelsAtom = atom<Area | null>({
    key: "croppedAreaPixelsAtom",
    default: null,
});

export const timestampAtom = atom<number | null>({
    key: "timestampAtom",
    default: null,
});

export const videoRefAtom = atom<HTMLVideoElement | null>({
    key: "videoRefAtom",
    default: null,
});
